import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class ProcessInvoicesService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;

obtenerMasterFacturasPro(sociedad, proveedor, fechai, fechaf, nea, nodocumento, tipo, referencia, oc, usuario): Observable<any> {
  const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('sociedad', sociedad)
      .set('provedor', proveedor)
      .set('nea', nea)
      .set('oc', oc)
      .set('fechai', fechai)
      .set('fechaf', fechaf)
      .set('estatus', '')
      .set('usuario', usuario)
      .set('nodocumento', nodocumento)
    };
    return this.http.get(this.basePath + 'master-factura/obtener-facturas', options);
 }

buscarFacturas(sociedad, proveedor, ordenCompra, fechaI, fechaF, nea, tipoFactura, referencia, pedimento, orden, documentoContable, usuario): Observable<any> {
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('sociedad', sociedad)
    .set('provedor', proveedor)
    .set('fechai', fechaI)
    .set('fechaf', fechaF)
    .set('nea', nea)
    .set('nodocumento', '')
    .set('estatus', '')
    .set('grupoimputacion', '')
    .set('tipo', tipoFactura)
    .set('referencia', referencia)
    .set('usuario', usuario)
    .set('pedimento', pedimento)
    .set('ordenCompra', orden)
    .set('documentoContable', documentoContable)
  };

  return this.http.get(this.basePath + 'master-factura/obtener-facturas', options);
}

obtenerZip(data): Observable<any> {
  const body = JSON.stringify(data);
  const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
  const options = {
    headers: httpHeaders,
    withCredentials: true,
  };
  return this.http.post(this.basePath + 'master-factura/obtener-zip', body, options);
 
}

cambiarStatus(uuid, estatus): Observable<any> {
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('uuid', uuid)
    .set('estatus', estatus)
  };
  return this.http.put(this.basePath + 'master-factura/cambio-estatus', '', options);
}

obtenerXML(sociedad, proveedor, fechai, fechaf, nea, nodocumento, tipo, referencia, oc, usuario): Observable<any> {
  const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('sociedad', sociedad)
      .set('provedor', proveedor)
      .set('nea', nea)
      .set('oc', oc)
      .set('fechai', fechai)
      .set('fechaf', fechaf)
      .set('estatus', '')
      .set('usuario', usuario)
      .set('nodocumento', nodocumento)
    };
    return this.http.get(this.basePath + 'master-factura/excel-facturas-pendientes-complemento', options);
 }

 downloadXml(base64Route: string) {
    const params = new HttpParams()
      .set('ruta', base64Route);

    return this.http.get(`${this.basePath}master-factura/obtener-xml`, { 
      responseType: 'blob',
      params 
    });
  }

 downloadPdf(base64Route: string) {
    const params = new HttpParams()
      .set('ruta', base64Route);

    return this.http.get(`${this.basePath}master-factura/obtener-pdf`, { 
      responseType: 'blob',
      params
    });
  }

 downloadExcelReport(params): Observable<any> {
    return this.http.get(`${this.basePath}master-factura/excel-facturas-pendientes-complemento${params}`, { 
      responseType: 'blob' 
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/process-invoices/process-invoices.service.ts